import { updateObject } from 'utils/updateObject'
import { parse } from 'date-fns'
import {
  MODIFY_BUDGETS_BY_RULE,
  MODIFY_DATES,
  SET_ROWS,
  UPDATE_ROW,
  UPDATE_ROWS_STATE,
} from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/types'

const initialState = {
  budget: {
    rows: [],
    touched: false,
  },
  dates: {
    rows: [],
    touched: false,
  },
}

const setRows = (state, { payload }) =>
  updateObject(state, {
    ...state,
    budget: { rows: payload.rows },
    dates: { rows: payload.rows },
  })

const updateRow = (state, { payload }) =>
  updateObject(state, {
    ...state,
    [payload.type]: {
      ...state[payload.type],
      rows: state[payload.type].rows.map((row) =>
        row.external_id === payload.external_id
          ? {
              ...row,
              ...payload.update,
              rowState: {
                ...(row.rowState ?? {}),
                touched: true,
                updated: false,
                error: false,
                errors: null,
              },
            }
          : row,
      ),
    },
  })

const modifyBudgetsByRule = (
  state,
  { payload: { budgetType, amount, modificationType } },
) =>
  updateObject(state, {
    ...state,
    budget: {
      ...state.budget,
      rows: state.budget.rows.reduce((acc, row) => {
        const updatedRow = { ...row }

        if (row.budget_limit !== null || row.budget_limit_day !== null) {
          const setToNull =
            budgetType === 'budget_limit' ? 'budget_limit_day' : 'budget_limit'

          switch (modificationType) {
            case 'set':
              updatedRow[budgetType] = amount
              break
            case 'increase':
              updatedRow[budgetType] = updatedRow[budgetType] + amount
              break
            case 'decrease':
              updatedRow[budgetType] =
                updatedRow[budgetType] - amount >= 0
                  ? updatedRow[budgetType] - amount
                  : 0
              break
          }

          updatedRow[setToNull] = null
          updatedRow.rowState = {
            ...(row.rowState ?? {}),
            touched: true,
            errors: null,
            error: null,
          }
        }

        acc.push(updatedRow)

        return acc
      }, []),
    },
  })

const modifyDates = (
  state,
  { payload: { resource, date_start = undefined, date_end = undefined } },
) => {
  return updateObject(state, {
    ...state,
    dates: {
      ...state.dates,
      rows: state.dates.rows.map((row) => {
        let newDateStart = row.date_start
        let newEndDate = date_end ? date_end : row.date_end

        if (date_start) {
          if (resource === 'ad-groups') {
            if (
              parse(date_start, 'yyyy-MM-dd', new Date()) <
              parse(row.date_start, 'yyyy-MM-dd', new Date())
            ) {
              newDateStart = row.date_start
            } else {
              newDateStart = date_start
            }
          } else {
            newDateStart = date_start
          }
        }

        const isTouched =
          newDateStart !== row.date_start || newEndDate !== row.date_end

        return {
          ...row,
          date_start: newDateStart,
          date_end: newEndDate,
          rowState: {
            ...(row?.rowState ?? {}),
            touched: isTouched,
            errors: null,
            error: null,
          },
        }
      }),
      touched: true,
    },
  })
}

const updateRowsState = (state, { payload: { type, items } }) =>
  updateObject({
    ...state,
    [type]: {
      ...state[type],
      rows: state[type].rows.reduce((acc, row) => {
        if (items[row.external_id]) {
          acc.push({
            ...row,
            rowState: {
              ...row.rowState,
              ...items[row.external_id].rowState,
            },
          })
        } else {
          acc.push(row)
        }

        return acc
      }, []),
    },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ROWS:
      return setRows(state, action)
    case UPDATE_ROW:
      return updateRow(state, action)
    case UPDATE_ROWS_STATE:
      return updateRowsState(state, action)
    case MODIFY_BUDGETS_BY_RULE:
      return modifyBudgetsByRule(state, action)
    case MODIFY_DATES:
      return modifyDates(state, action)
    default:
      return state
  }
}

export default reducer
